import { lazy, Suspense, useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './routes/Home';
import Prereqs from './routes/Prereqs';
import Ingredients from './routes/Ingredients';
import Utensils from './routes/Utensils';
import Equipment from './routes/Equipment';
import Notes from './routes/Notes';
import Hotspots from './routes/Hotspots';
import Planner from './routes/Planner';
import Preview from './routes/Preview';
import Cook from './routes/Cook';
import { theme } from './design/theme';

// `/__design` is a dev-only gallery (Phase 4). The conditional `lazy`
// import is statically analysable by Vite: when `import.meta.env.DEV`
// is `false` in a production build the branch is dead-code eliminated
// and the DesignLab chunk is never emitted. Verify with
// `grep -r DesignLab apps/web/dist` after `pnpm run build`.
const DesignLab = import.meta.env.DEV ? lazy(() => import('./routes/DesignLab')) : null;

export default function App() {
  // Bind the focus-ring colour to a CSS custom property on <body> so
  // styles.css (which can't import from theme.ts) still consumes the
  // single-source-of-truth token. The DesignLab can override at runtime
  // by setting the same property on a parent. README §8.
  useEffect(() => {
    if (typeof document === 'undefined') return;
    document.body.style.setProperty('--cc-focus-ring', theme.accent.action);
  }, []);
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/prereqs" element={<Prereqs />} />
        <Route path="/ingredients" element={<Ingredients />} />
        <Route path="/utensils" element={<Utensils />} />
        <Route path="/equipment" element={<Equipment />} />
        <Route path="/notes" element={<Notes />} />
        <Route path="/hotspots" element={<Hotspots />} />
        <Route path="/planner" element={<Planner />} />
        <Route path="/preview" element={<Preview />} />
        <Route path="/cook" element={<Cook />} />
        {DesignLab && (
          <Route
            path="/__design"
            element={
              <Suspense fallback={null}>
                <DesignLab />
              </Suspense>
            }
          />
        )}
      </Routes>
    </BrowserRouter>
  );
}
